import { configTypes, licenseConfigTypes } from './list-constants';

export function isCustomFilteredLicenseRegType(regType) {
  return regType.startsWith(`${configTypes.STR_LICENSE}-`);
}

export function isLicenseConfigRegType(regType) {
  return (
    licenseConfigTypes.includes(regType) ||
    isCustomFilteredLicenseRegType(regType)
  );
}
